<template>
  <v-dialog
    data-testid="login-modal-tooManyAttemts"
    max-width="372"
    :value="show"
  >
    <v-card>
      <v-card-title>
        {{ $t('authManagePeople.login_failed') }}
      </v-card-title>
      <v-card-text>{{
        $t('error.auth.account_is_temporary_blocked')
      }}</v-card-text>
      <v-card-actions class="justify-end">
        <Button
          plain
          color="primary"
          data-testid="login-button-tooManyAttemts"
          :text="$t('common.button.close')"
          @click="$emit('close')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from '@/components/UI/Button'

export default {
  name: 'TooManyAttemptsModal',

  components: {
    Button,
  },

  props: {
    show: Boolean,
  },
}
</script>
